// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"a7f14fe0","650":"f0bf049f"}[chunkId] + ".chunk.js";
};